import { useState, useEffect } from "react";
import TableTop from "../TableComponents/TableTop";
import { Table, TableBody } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import MessagesInRequestTableHead from "../TableHeads/MesagesInRequestTableHead";
import MessagesInRequestTableRow from "../TableRows/MessagesInRequestTableRow";
import { getOtherMessages } from "../../../reduxStore/entities/messages";

const MessagesInOtherRequestsTable = () => {
    const [isTableShown, setIsTableShown] = useState(true);

    const dispatch = useDispatch();

    const [loaded, setLoaded] = useState(false);

    const fetchedMessagesInOtherOffers = useSelector((state) => state.messages.otherMessages);
    const count = useSelector((state) => state.messages.otherMessagesCount);

    useEffect(() => {
        setLoaded(true);
    }, [fetchedMessagesInOtherOffers]);

    useEffect(() => {
        dispatch(getOtherMessages());
    }, []);

    if (!loaded) {
        return null;
    };


    return (
        <div style={styles.mainContainer}>
            <TableTop
                title={"Ostale poruke"}
                count={count}
                open={isTableShown}
                setOpen={setIsTableShown}
            />

            {isTableShown && (
                <div style={styles.tablePaddingDiv}>
                    <div style={styles.tableBorderDiv}>
                        <Table>
                            <MessagesInRequestTableHead />

                            <TableBody>

                                {fetchedMessagesInOtherOffers.map((row, index) => (
                                    <MessagesInRequestTableRow
                                        key={index}
                                        partOffer={row}
                                    />
                                ))}

                            </TableBody>

                        </Table>

                    </div>
                </div>
            )}

        </div>
    );
};


export default MessagesInOtherRequestsTable;

const styles = {
    mainContainer: {

    },
    tablePaddingDiv: {
        paddingInline: 30,
    },
    tableBorderDiv: {
        borderLeft: "1px solid rgba(0, 0, 0, 0.12)",
        borderRight: "1px solid rgba(0, 0, 0, 0.12)"
    }
};